module.exports = window.__federationLoadRemote("moduleHub");